import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MobileInsuranceDetails, MobileScenarios} from '../../../model/MobileInsuranceModels';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Label, Response, StaticMethods} from '../../../model/GeneralModels';
import {MobileInsuranceService} from '../../../services/mobile-insurance.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-mobile-guest-status',
  templateUrl: './mobile-guest-status.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class MobileGuestStatusComponent implements OnInit, AfterViewInit {
  requestInfo: MobileInsuranceDetails[] = [];
  formGroup: FormGroup;
  file = new Label('', '');
  pageStatus: string;
  buttonLabel = '';
  requestID: number;
  icon: string;
  requestToken: string;
  data: Observable<any>;
  private mobile: string;
  translation: any = {};

  constructor(
    private service: MobileInsuranceService,
    private router: Router,
    public settings: AppSettingsService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.route.paramMap.pipe(
      switchMap(params => {
        // (+) before `params.get()` turns the string into a number
        this.mobile = params.get('mobile');
        this.requestToken = params.get('requestToken');
        return this.service.getRequestID(this.mobile, this.requestToken);
      })).subscribe((response: Response) => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        this.requestInfo[0] = new MobileInsuranceDetails(response.data, MobileScenarios.generalScenario);
        this.setButton(this.requestInfo[0]);
      } else {
        this.router.navigate(['/mobile/guest']);
      }
    });
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  takeAction() {
    if (this.requestInfo[0].getStep() === MobileScenarios.insuranceReleased) {
      this.download();
    }
  }

  setButton(request: MobileInsuranceDetails) {
    const buttonElement: HTMLElement = document.getElementById(request.getRequestID() + '_select_offer_button');
    buttonElement.style.display = 'none';
    switch (request.getStep()) {
      case MobileScenarios.insuranceReleased:
        this.pageStatus = MobileScenarios.insuranceReleased;
        this.buttonLabel = 'دانلود بیمه نامه';
        break;
      default:
        this.pageStatus = MobileScenarios.waitingForRelease;
        this.buttonLabel = '';
    }
  }

  download() {
    this.service.downloadNewInsurance(this.requestInfo[0].getRequestID()).subscribe((response: Response) => {
      if (response.success) {
        StaticMethods.goToLink(response.data.directLink);
      }
    });
  }

}
